import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
export function Guarantee() {
  return <section className="w-full bg-ivory px-5 py-16 md:px-8 md:py-24" data-id="element-173" data-mp="1o33t0dp8bmg6">
      <div className="mx-auto max-w-3xl rounded-3xl border-2 border-gold-400 bg-white p-7 text-center sm:p-12" data-id="element-174" data-mp="223oexiqfxydw">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full bg-navy-900 text-gold-400 ring-4 ring-gold-400" data-id="element-175" data-mp="1x5mvuxt0lz2f">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-176" data-mp="19cejrgvbwhey" />
          <span className="mt-0.5 text-xs font-extrabold uppercase" data-id="element-177" data-mp="14h8xui1xf2qv">7 days</span>
        </div>
        <h2 className="mt-6 font-serif text-[1.75rem] font-extrabold leading-tight text-navy-900 sm:text-4xl" data-id="element-178" data-mp="1j652s68orzn9">
          Your purchase is protected by a 7-day guarantee
        </h2>
        <p className="mt-4 text-lg font-bold text-gold-600" data-id="element-179" data-mp="qn7v7d7usvl8">Explore the blueprint with confidence.</p>
        <p className="mt-5 text-lg leading-relaxed text-ink" data-id="element-180" data-mp="lo4wsbmdpnm8">
          Get access to the complete digital collection and review the clinical workflows, templates,
          and documentation resources.
        </p>
        <p className="mt-4 text-lg leading-relaxed text-ink" data-id="element-181" data-mp="tx1p4novge3h">
          If the resource isn’t right for your professional needs, you can request a refund within
          seven days of purchase under the stated guarantee.
        </p>
        <SectionCTA label="Get the Complete Blueprint for $27" data-id="element-182" data-mp="12sr7env0wscn" />
      </div>
    </section>;
}